// extracted by mini-css-extract-plugin
export default {"body":"BaseLayout_body__yuVLk","bodyFixed":"BaseLayout_bodyFixed__gRedq","container":"BaseLayout_container__t2dN9"};